import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Legacy magic-link route.
 *
 * Supabase and older generated links can still land on `/auth/magic-link`.
 * Redirect them into the newer `/auth/callback` handler so PKCE, hash-token,
 * and recovery/session flows all use one robust implementation path.
 */
export default function MagicLinkCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/auth/callback${window.location.search}${window.location.hash}`, {
      replace: true,
    });
  }, [navigate]);

  return null;
}
